import React from "react";

import API from "@beardeddevops/react.api";
import Types from "constants/Types";
import Framework from "@beardeddevops/react.framework";
import ReactTable from "react-table";
import moment from "moment";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";

export default class Users extends Framework.Components.Collection {
	constructor(props) {
		let model = new API.BuildClass(Types.Alerts._name, API.RequestType.READ_ALL);
		super(props, model);
	}

	render() {
		const {data, pages, limit, loading} = this.state;
		const columns =[
			{
				Header: "Date Created",
				id: "created",
				accessor: obj => (moment(obj.created).local().format('MM/DD/YYYY h:mm A'))
			},
			{
				Header: "Creator",
				id:"creator",
				accessor: d => <a href={`/users/${d.creator}`}>{d.creator_name}</a>,
			},
			{
				Header: "Message",
				accessor: "message",
			},
			{
				Header: "User",
				id: "user_receiving",
				accessor: d => <a href={`/users/${d.user_receiving}`}>{d.receiving_name}</a>,
			},
		]
		return (
			<Card>
				<CardContent>
					<div className="table-bar">
						<div className="d-flex">
							{this.renderSearch('Alerts')}
							{this.renderHeaderRight("Alerts",columns)}
						</div>
					</div>
					<ReactTable
						key={this.state.key}
						columns={columns}
						manual // Forces table not to paginate or sort automatically, so we can handle it server-side
						data={data}
						pages={pages} // Display the total number of pages
						loading={loading} // Display the loading overlay when we need it
						loadingText="Requesting Data"
						onFetchData={this.fetchData} // Request new data when things change
						expanderDefaults={{
							sortable: true,
							resizable: true,
							filterable: true,
							width: undefined
						}}
						defaultSorted={[
							{
								id: this.model.sort,
								desc: this.model.order === 'desc'
							}
						]}
						showPagination={true}
						defaultPageSize={limit}
						className="-striped -highlight"
						onPageSizeChange={this.onPageSizeChange}
						pageSize={limit}
					/>

					<Framework.Elements.LoadingSpinner isLoading={loading}/>
				</CardContent>
			</Card>
		)
	}
}
